import { ChartStylesModel } from './chart-styles.model';
import { CoverageMetricChartDisplaySettings } from './coverage-metric-chart-display-settings.model';


export class CoverageMetricChartStyles extends ChartStylesModel {

    override chartDisplaySettings: CoverageMetricChartDisplaySettings;

    constructor(api?: any) {
        super(api);
        this.chartDisplaySettings = new CoverageMetricChartDisplaySettings(this);
    }

    equals(other: CoverageMetricChartStyles, compareTemplate: boolean): boolean {
        if (!super.equals(other, compareTemplate)) {
            return false;
        }

        if (!this.chartDisplaySettings.isEqual(other.chartDisplaySettings)) {
            return false;
        }

        return true;
    };
}
